import { createSlice } from "@reduxjs/toolkit";
import { ILeadSlice } from "./type";
import { createUpdateLead, fetchLeadDetailsById, fetchLeadIds, fetchLeads } from "./thunk";



export const leadSlice = createSlice({
  name: "leads",
  initialState: {
    leads: [],
    leadIds: [],
    leadDetail: null,
  } as ILeadSlice,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetchLead
    builder.addCase(fetchLeads.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeads.fulfilled, (state, action) => {
      state.isLoading = false;
      state.leads = action.payload;
    });
    builder.addCase(fetchLeads.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchleadIds
    builder.addCase(fetchLeadIds.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeadIds.fulfilled, (state, action) => {
      state.isLoading = false;
      state.leadIds = action.payload;
    });
    builder.addCase(fetchLeadIds.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchCustomerDetailsById
    builder.addCase(fetchLeadDetailsById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeadDetailsById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.leadDetail = action.payload;
    });
    builder.addCase(fetchLeadDetailsById.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // createUpdateLead
    builder.addCase(createUpdateLead.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createUpdateLead.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createUpdateLead.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { reducer } = leadSlice;
